import axios from "axios";
import {useMutation, useQueryClient} from "@tanstack/react-query";

/*** Mutations **********************/

export const checkBlackListMutation = (params) => {
    return axios.post(
        `/api/blacklist`, params
    ).then(res => res.data);
}

export const useCheckBlackListMutation = (mutator = checkBlackListMutation) => {
   const queryClient = useQueryClient()
   return useMutation(
       ['blacklist'],
       (params) => mutator(params),
       {onSuccess: () => queryClient.invalidateQueries(["blacklist"])}
   );
}